// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import plugins from './plugins';
import views from './views';
import storage from './storage';
import app from './app';

export default {
    views,
    plugins,
    storage,
    app,
};
